import {Pipe, PipeTransform} from "@angular/core";
import {KeyValue} from "@angular/common";

@Pipe({
	name: "dictionary",
	pure: true,
	standalone: true,
})
export class DictionaryPipe implements PipeTransform {
	//transform<K extends number, V>(value: { [key: number]: V }): KeyValue<number, V>[];
	transform<K extends string, V>(value: {[key: string]: V}): KeyValue<K, V>[] {
		let ret: KeyValue<K, V>[] = [];
		if (value == null) {
			return ret;
		}
		Object.entries(value).forEach(([key, value]) => ret.push({key: <K>key, value: value}));
		return ret;
	}
}
